import { useCallback } from 'react';
import { getToastMessage } from 'shared/lib';
import { SwitchChainError } from 'viem';
import { useSwitchChain } from 'wagmi';

import { useSupportedChains } from '../useSupportedChains';

export const useSwitchNetwork = (onSuccess?: () => void, onError?: (error?: unknown) => void) => {
  const { switchChainAsync, isPending } = useSwitchChain();
  const { chain, normalizedChains, chains: supportedChains } = useSupportedChains();

  const switchAsync = useCallback(
    async (value: string) => {
      const selectedChain = normalizedChains[Number(value)];

      if (!selectedChain) return;

      try {
        await switchChainAsync({ chainId: selectedChain.id as Parameters<typeof switchChainAsync>[0]['chainId'] });
        getToastMessage('success', `Switched to ${selectedChain.name}`);

        onSuccess?.();
      } catch (error: unknown) {
        // @ts-expect-error code insurance
        if (error instanceof SwitchChainError && error?.cause?.code === -32002) {
          getToastMessage('info', 'Request to your wallet has been already sent');
          return;
        }
        onError?.(error);
      }
    },
    [normalizedChains, switchChainAsync, onSuccess, onError],
  );

  return {
    switchAsync,
    chain,
    supportedChains,
    normalizedChains,
    isSwitching: isPending,
  };
};
